<template>
    <div>
        <page-title>客服管理</page-title>
        <page-body>

            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/customer/edit">
                            <el-button type="text">手动添加</el-button>
                        </router-link>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="nickname" label="客服">
                    <template slot-scope="scope">
                        <div>{{scope.row.nickname}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="pic_url" label="二维码">
                    <template slot-scope="scope">
                        <img :src="scope.row.pic_url" style="width: 46px;height: 46px"/>
                    </template>
                </el-table-column>
                <el-table-column label="排序" prop="sort"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <router-link :to="'/dashboard/admin/customer/edit?id=' + scope.row.id">编辑</router-link>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="deleteCustomer(scope.row)">删除</el-button>
                        </template>
                        <template v-else>
                            <span style="color: #909399">已删除</span>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="recoveryCustomer(scope.row)">恢复</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            list: null,
            pagination: null,
            keyword: ''
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/customer/index',
                    params: {
                        page: page,
                        keyword: this.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        deleteCustomer(customer) {
            new Promise(resolve => {
                this.$confirm('此操作将删除该客服, 是否继续?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(customer)
                }).catch(() => {
                })
            }).then(customer => {
                this.loading = true
                axios({
                    url: 'admin/customer/delete',
                    params: {
                        id: customer.id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        customer.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        recoveryCustomer(customer) {
            this.loading = true
            axios({
                url: 'admin/customer/recovery',
                params: {
                    id: customer.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    customer.is_delete = 0
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
